/**
 * React CSP Patch - Ensures React DOM uses CSP nonce for inline styles
 */
import { getCspNonce } from './csp';

export function patchReactForCsp() {
  const nonce = getCspNonce();
  if (!nonce) {
    console.warn('[CSP] No nonce available for React CSP patch');
    return;
  }

  try {
    // Tell React about our CSP nonce
    if (window.__REACT_NONCE__ === undefined) {
      window.__REACT_NONCE__ = nonce;
    }

    // In case React hasn't picked up the nonce from the script tag
    if (window.__webpack_nonce__ === undefined) {
      window.__webpack_nonce__ = nonce;
    }

    // Additional patch for React 16+ style injection
    if (typeof document !== 'undefined') {
      // Patch the createElement method to add nonce to style elements
      const originalCreateElement = document.createElement.bind(document);
      document.createElement = function(tagName) {
        const element = originalCreateElement(tagName);
        if (tagName.toLowerCase() === 'style') {
          element.setAttribute('nonce', nonce);
        }
        return element;
      };
      
      // For React 18 and newer
      if (window.React && window.React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) {
        try {
          const ReactDOM = window.ReactDOM || (window.React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint ? 
            window.__CLIENT_ENTRY_POINT_REACT_DOM__ : null);
            
          if (ReactDOM && ReactDOM.createRoot) {
            console.log('[CSP] Patching React 18 createRoot');
            const originalCreateRoot = ReactDOM.createRoot;
            ReactDOM.createRoot = function(container, options) {
              options = options || {};
              options.identifierPrefix = options.identifierPrefix || '';
              options.nonce = nonce;
              return originalCreateRoot(container, options);
            };
          }
        } catch (e) {
          console.warn('[CSP] Failed to patch React 18 createRoot:', e);
        }
      }
    }

    console.log('[CSP] React patched successfully with nonce');
  } catch (err) {
    console.error('[CSP] Error patching React for CSP:', err);
  }
}
